export const tableData = [
  {
    id: '1234',
    name: 'Jane Smith',
    dob: '12/31/1990',
    address: 'Boston, MA',
    email: 'jsmith@email.com',
    emailVerified: true,
    balance: '$2,200'
  },
  {
    id: '5678',
    name: 'Joe Smith',
    dob: '01/01/1980',
    address: '',
    email: 'joe.smith@email.com',
    emailVerified: true,
    balance: '$1,350'
  },
  {
    id: '0000',
    name: 'Mary Lou',
    dob: '06/15/1985',
    address: (
      <>
        <div>100 Main St.</div>
        <div>Springfield, USA</div>
      </>
    ),
    email: '',
    balance: '-$175'
  }
];

export const commitsData = [
  {
    id: '1407c5fcbe460aa06a78b4779583917599d9bd78',
    author: 'Scott Farmer',
    date: 'Fri Jan 28',
    message: 'pkg: Version 3.0.0-dev.2.1.'
  },
  {
    id: '902716be61eed70280178c01db19fwa504f57a51',
    author: 'Scott Farmer',
    date: 'Fri Jan 28',
    message: 'fix(core:Menu): Adds missing icon registrations.'
  },
  {
    id: '8b7916b1d8691fec1d884eadb445019a44ba6c6b',
    author: 'Sam Singh',
    date: 'Fri Jan 28',
    message: 'fix(core:Currency): Fixes decimal truncation. Updates the tests.'
  },
  {
    id: '7d119a2af6d6de9516da3e4eddf8e4523152358e',
    author: 'Sam Singh',
    date: 'Wed Jan 26',
    message: 'docs(work:Details): Updates the demo.'
  },
  {
    id: '41f0875a5b049d40081w0bf8bbae0279ee469fe6',
    author: 'Scott Farmer',
    date: 'Tue Jan 25',
    message: 'fix(core:icons): Updates minus icon to be more centered.'
  },
  {
    id: '9f5996ebd2d9076b53bff2cf8a641v292bcbc256',
    author: 'Anna Florence',
    date: 'Wed Jan 26',
    message: 'docs(core:Toaster): Modifies Toaster demo to incorporate wrapping Toaster component.'
  },
  {
    id: '6125f52db79bc1ada47e195e36d01927443b0e1c',
    author: 'Anna Florence',
    date: 'Tue Jan 25',
    message:
      'docs: Modifies copy-demos script to maintain relative paths for all inner demo package imports.'
  },
  {
    id: '1eceb3ef9539e22225ab287428d7902ee19b5753',
    author: 'Scott Farmer',
    date: 'Fri Jan 21',
    message: 'pkg: Version 3.0.0-dev.2.0.'
  },
  {
    id: 'aeb1e26fa8f0f2ae29f93ae07ac3c98dde3ade46',
    author: 'Scott Farmer',
    date: 'Fri Jan 21',
    message: 'pkg: Updates types packages for React 17.'
  },
  {
    id: '55a2c452559a59bcadedb0020b03675c3234a238',
    author: 'Jan Stark',
    date: 'Mon Jan 17',
    message: 'fix(core:MultiStep): Fixes position of step labels.'
  },
  {
    id: 'f1e1a36e86de7a8e33684b44203a36d6622b39f6',
    author: 'Yan Miller',
    date: 'Wed Jan 19',
    message: 'fix(social:Email): Fixes the persistent utility resize issue with email components.'
  },
  {
    id: '82ed6caa36f4518de7af66aff80dee7b128c23d4',
    author: 'Anna Florence',
    date: 'Wed Jan 19',
    message: 'docs: Adds demos for component customization, configuration, and theme.'
  },
  {
    id: '6e0702db4cc0c59375006dfd36f9a943953d0716',
    author: 'Anna Florence',
    date: 'Wed Jan 19',
    message: 'style: Re-orders component theme definitions to be in alphabetical order.'
  },
  {
    id: '3cc54ccc2a2287019594eda4db68838aa1f32b0b',
    author: 'Sam Singh',
    date: 'Fri Jan 21',
    message: 'docs(work:Details): Fixes displaying currency fields in the demo file.'
  },
  {
    id: '38ba5f8a83681345d9568b9a7c3693bd30af7be8',
    author: 'Sam Singh',
    date: 'Fri Jan 21',
    message:
      'fix(core:Number)!: Enables rounding for NumberDisplay component. Fixes decimal precision support.'
  },
  {
    id: '5914d105574e12f4c3aae6a616c54ce9cc4f70bf',
    author: 'Yan Miller',
    date: 'Thu Jan 20',
    message: 'fix(core:TextArea): Fixes ios safari focus styling issue.'
  },
  {
    id: 'b03f783df31634a334e1c46c76c30391a8907080',
    author: 'Sam Singh',
    date: 'Mon Dec 20',
    message: 'fix(core:Currency)!: Enables rounding for CurrencyDisplay.'
  },
  {
    id: '759536fb5e257a3a3c0b85d3cb2b63565f3b30e1',
    author: 'Scott Farmer',
    date: 'Wed Jan 19',
    message: 'pkg: Updates development versions of React and ReactDOM to 17.0.2.'
  },
  {
    id: 'dcf4a23758f6eaca62bad5f50a9bf1b281ad931b',
    author: 'Sam Singh',
    date: 'Tue Jan 18',
    message: 'refactor(build:Workbench): Optimizes CSS for zoom.'
  },
  {
    id: '94186cf82de48c3a4cbea158f25ad471cd49b9e4',
    author: 'Sam Singh',
    date: 'Tue Jan 18',
    message: 'fix(build:Workbench): Adds tooltip to close button.'
  },
  {
    id: 'da16bdc203ddb10a5ad9c48882a73d9587daa198',
    author: 'Sam Singh',
    date: 'Mon Jan 17',
    message: "fix(build:Workbench): Corrects component's expanding in Page Templates."
  },
  {
    id: '8dd5d2190aaaf72ae4aac70af42d16365845fb18',
    author: 'Sam Singh',
    date: 'Mon Jan 17',
    message: 'fix(build:Workbench): Truncates long headings.'
  }
];
